import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [themePreference, setThemePreferenceState] = useState(
    () => localStorage.getItem('theme') || 'system'
  );

  useEffect(() => {
    const apply = () => {
      const effective =
        themePreference === 'system'
          ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
          : themePreference;
      document.documentElement.setAttribute('data-bs-theme', effective);
    };

    apply();

    if (themePreference === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [themePreference]);

  const setTheme = (pref) => {
    setThemePreferenceState(pref);
    localStorage.setItem('theme', pref);
  };

  return (
    <ThemeContext.Provider value={{ themePreference, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
